export default "__VITE_ASSET__LN6jxbJj__"